/* eslint-disable camelcase */
import { createTrackEvent as track } from 'utils/segment';
import { getCollectionInfo } from 'modules/catalog/collectionBuilder/segment';
import * as t from './actionTypes';

export const getCollectionDataFromAction = (collectionAction = {}) => {
  const { catalogName, id, name } = collectionAction;
  return { associated_catalog: catalogName, collection_id: id, collection_name: name };
};

export const formatDefinedEvent = (e, state) => {
  const { associated_catalog, collection_name } = getCollectionInfo(state);
  return { associated_catalog, collection_name };
};

export const formatTemplateEvent = (e, state, action) => {
  const { collectionData } = action;
  return getCollectionDataFromAction(collectionData);
};

export const formatDeleteEvent = (e, state, action) => {
  const { collection } = action;
  return getCollectionDataFromAction(collection);
};

export default {
  [t.SUBMIT_CREATE_MODAL]: track('Defined Catalog Collection', [], formatDefinedEvent),
  [t.DELETE_CATALOG_COLLECTION]: track('Collection Deleted', [], formatDeleteEvent),
  [t.OPEN_HANDLEBARS_MODAL]: track('Clicked Collection Template Helper', [], formatTemplateEvent),
  [t.COPY_HANDLEBARS]: track('Copied Collection Template Text'),
};
